var FaqOptions = function() {

	var comp = $("[data-component='faq-options']"),
			header = $('[data-component="header"]');

	this.init = function() {

		this.activeItem();
	}

	this.activeItem = function() {

		comp.find('.img-holder').on('click', function(e) {
			e.preventDefault();
			comp.find('.item').removeClass('active');
      $(this).closest('.item').addClass('active');

      if($(window).width() < 768) {
      	$('html, body').animate({
					scrollTop: $('[data-component="faq-item"]').offset().top - header.height()
				}, 700);
      }
		});

	}

	return this.init();
}
